import { useNavigation } from "expo-router";
import { useCallback, useLayoutEffect } from "react";
import { Platform } from "react-native";

import type {
  LeftAction,
  RightAction,
} from "$src/core/components/organisms/StackHeader/StackHeader";
import StackHeader from "$src/core/components/organisms/StackHeader/StackHeader";

const useStackHeader = (options: {
  left?: LeftAction | undefined;
  right?: (RightAction | undefined | null | false)[] | undefined;
}) => {
  const navigation = useNavigation();

  const renderHeader = useCallback(
    () => (
      <StackHeader left={options.left} right={options.right?.filter(Boolean)} />
    ),
    [options.left, options.right],
  );

  /* Configure the transparent stack header once navigation is ready. */
  useLayoutEffect(() => {
    if (!Platform.isTV) {
      navigation.setOptions({
        headerShown: true,
        headerTransparent: true,
        headerTitle: "",
        header: renderHeader,
      });
    }
  }, [navigation, renderHeader]);
};

export default useStackHeader;
